
const BePartner = () => {
  return (
    <div className="container py-5">
      {/* Hero Section */}
      <div className="text-center mb-5">
        <h1 className="display-5 fw-bold" style={{color:'#d4af37'}}>Become Our Service Partner</h1>
        <p className="lead text-dark">Join hands with us and grow your business together. Let’s build something amazing.</p>
      </div>

      {/* Partnership Benefits */}
      <div className="row mb-5">
        <div className="col-md-4">
          <div className="card text-white h-100 shadow-sm" style={{backgroundColor:'#4b1e28'}}>
            <div className="card-body text-center">
              <h5 className="card-title">Collaborate & Grow</h5>
              <p className="card-text">Partner with us to leverage our expertise and expand your offerings to new markets.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card text-white h-100 shadow-sm" style={{backgroundColor:'#0b3d2e'}}>
            <div className="card-body text-center">
              <h5 className="card-title">Shared Success</h5>
              <p className="card-text">We believe in win-win partnerships. Your success is our mission.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card bg-dark text-white h-100 shadow-sm">
            <div className="card-body text-center">
              <h5 className="card-title">Dedicated Support</h5>
              <p className="card-text">Get access to a dedicated team to assist you throughout the partnership journey.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <h3 className="mb-4 text-white rounded text-center" style={{backgroundColor:'#0b3d2e'}}>Let's Connect</h3>
          <form>
            <div className="mb-3">
              <label className="form-label bg-dark text-white rounded text-center">Your Name</label>
              <input type="text" className="form-control" placeholder="Enter your name" required />
            </div>
            <div className="mb-3">
              <label className="form-label bg-dark text-white rounded text-center">Email Address</label>
              <input type="email" className="form-control" placeholder="Enter your email" required />
            </div>
            <div className="mb-3">
              <label className="form-label bg-dark text-white rounded text-center">servicer Name</label>
              <input type="text" className="form-control" placeholder="Enter company name" />
            </div>
            <div className="mb-3">
              <label className="form-label bg-dark text-white rounded text-center ">Message</label>
              <textarea className="form-control" rows="4" placeholder="Tell us a bit about your partnership idea"></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Submit Request</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BePartner;
